<template>
  <div v-if="doneFetch" class="settings scrollbar">
      <h1>{{ organization.name }}</h1>
    
      <div class="row">
        <div class="col-2 flex-col"><h2>{{ orgSID }}</h2></div>
        <div class="col-4 flex-col">
          <h2>Subscription: {{ plan }}</h2>
        </div>
        <div class="col-3 flex-col">
          <span class="text-end"><h2>Funds: 
          USD  {{ funds.toFixed(2) }}</h2>
          </span>
        </div>
        <div class="col-3 flex-col">
          <span class="text-end"><h2>Credits: 
          USD  {{ credits.toFixed(2) }}</h2>
          </span>
        </div>
      </div>
    
      <hr>
      <div class="progress-container">
  
         <circProgress  
            text="Users"
            :value="numUsers"
            :maxValue="maxUsers"
            icon="mdi-account-multiple"
          />

          <circProgress  
            text="Projects"
            :value="numProjects"
            :maxValue="maxProjects"
            icon="mdi-folder"
          />

          <circProgress  
            text="Datasets"
            :value="numDatasets"
            :maxValue="maxDatasets"
            icon="mdi-database"
          />

          <circProgress  
            text="Images"
            :value="numImages"
            :maxValue="maxImages"
            icon="mdi-image"
          />

          <circProgress  
            text="Files"
            :value="numFiles"
            :maxValue="maxFiles"
            icon="mdi-file"
          />

          <circProgress  
            text="Storage"
            :value="numStorage"
            :maxValue="maxStorage"
            icon="mdi-harddisk"
            type="bytes"
          />

          <circProgress  
            text="Paid AI Services"
            :value="numPaidAIDollars"
            :maxValue="maxPaidAIDollars"
            icon="mdi-brain"
            type="$"
          />

            <circProgress  
            text="Free AI Services"
            :value="numFreeAIDollars"
            :maxValue="maxFreeAIDollars"
            icon="mdi-brain"
            type="$"
          />

      </div>
      <br>
  </div>
  <div v-else class="empty-state">
    <!-- <div id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div> -->
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import circProgress from '@/components/circularProgress.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();


export default {
  name: 'OrganizationUsageSummary',
  components: {
    circProgress
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      doneSummaryFetch:false,

      numProjects:0,
      maxProjects:100,
      numDatasets:0,
      maxDatasets:100,
      numUsers:0,
      maxUsers:100,
      numStorage:0,
      maxStorage:100,
      numPaidAIDollars:0,
      maxPaidAIDollars:100,

      funds:0,
      credits:0,

      plan:"",

    };
  },
  computed: {

    orgSID() {
      if (!this.organization ) return "";
      const id = "org-"+this.organization.id.toString(16);
      return id;
    },
    dollarRemaining() {
      let v=this.funds;
      return v;
    },
    doneFetch() {
      return this.doneSummaryFetch;
    },
    user() {
      return this.$store.state.user.user;
    },
    months() {
      return [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ];
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startingYear = 2023;
      const years = [];
      for (let year = startingYear; year <= currentYear; year++) {
        years.push(year);
      }

      return years;
    },
  },
  watch: {
    showDetailedDatasets(v) {
      if (v) {
        this.getDetailedDatasets();
      }
    },
    showDetailedImages(v) {
      if (v) {
        this.getDetailedImages();
      }
    },
    selectTimeZone(val) {
      if (val === 'utc') {
        this.timeZone = 'UTC';
      } else if (val === 'local') {
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      this.retrieveMonthlyBill();
    },
  },
  created() {
    if (this.$route.query.org) {
      this.orgId = parseInt(this.$route.query.org);
    }
    this.selectMonth = this.months[new Date().getMonth()];
    this.selectYear = new Date().getFullYear();
  },
  async mounted() {
    await this.getOrganization();
    await this.getUsagePercentage();
  },
  methods: {
 
    async getOrganization() {
      await this.dsConn.getOrg({ organization_id: this.orgId })
        .then((resp) => {
          if (resp.result) {
            this.organization = resp.result;
          } else if (!resp || resp.error) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error getting organization`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error getting organization`,
            type: "error",
            position: "top",
          });
        });
    },
    async getAllInstances() {
      await this.dsConn.getAllInstances()
        .then((resp) => {
          if (resp.result) {
            this.instances = resp.result;
          } else if (!resp || resp.error) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error getting instances`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error getting instances`,
            type: "error",
            position: "top",
          });
        });
    },
    async getRecentBills() {
      await this.dsConn.getRecentBills()
        .then((resp) => {
          if (resp.result) {
            this.bills = resp.result;
          } else if (resp.error) {
            throw new Error(resp.errror.message);
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving recent bills: ${e}`,
            type: "error",
            position: "top",
          });
        });
    },
    async retrieveMonthlyBill() {
      this.doneDetailsFetch = false;
      await this.dsConn.retrieveMonthlyBill({
        organization_id: this.orgId,
        transaction_id: this.selectedBill?.id,
      })
        .then((resp) => {
          if (resp.result && Object.keys(resp.result).length > 0 && this.costPackage) {
            this.parseReport(resp.result);
          } else {
            this.parseReport([]);
          }
          this.doneDetailsFetch = true;
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving monthly bill`,
            type: "error",
            position: "top",
          });
          this.doneDetailsFetch = true;
        });
    },
    async getCostPackage() {
      await this.dsConn.getCostPackage({ organization_id: this.orgId })
        .then((resp) => {
          if (resp.result) {
            this.costPackage = resp.result;
          } else if (!resp || resp.error) {
            this.costPackage = null;
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error getting cost package`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error getting cost package`,
            type: "error",
            position: "top",
          });
        });
    },

    async getUsagePercentage() {
      this.doneSummaryFetch = false;
      await this.dsConn.getUsageSummaryForOrganization({ organization_id: this.orgId })
        .then((resp) => {
          if (resp.result) {
            let used=resp.result.quota.used;
            let quota=resp.result.quota.quota;
            let sum=resp.result;

            this.numProjects=used.projects;
            this.maxProjects=quota.projects;

            this.numImages=used.images;
            this.maxImages=quota.images;

            this.numUsers=used.users;
            this.maxUsers=quota.users;

            this.numFiles=used.files;
            this.maxFiles=quota.files;

            this.numProjects=used.projects;
            this.maxProjects=quota.projects;

            this.numDatasets=used.datasets;
            this.maxDatasets=quota.datasets;

            this.numPaidAIDollars=sum.paid_usage;
            this.maxPaidAIDollars=sum.funds_start_month;

            this.numFreeAIDollars=sum.free_usage;
            this.maxFreeAIDollars=quota.ai_dollars;

            this.numUsers=used.users;
            this.maxUsers=quota.users;

            this.numStorage=used.storage;
            this.maxStorage=quota.storage;

            this.funds = (sum.funds);
            this.credits=(sum.credits);

            this.plan=quota.description;


          } else if (!resp || resp.error) {
            this.costPackage = null;
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error getting usage summary`,
              type: "error",
              position: "top",
            });
          }
          this.doneSummaryFetch = true;
        })
        .catch((e) => {
          this.doneSummaryFetch = true;
        });
    },
    async getDetailedDatasets() {
      if (!this.hasDetailedDatasets) {
        await this.dsConn.getDetailedDatasets({ organization_id: this.orgId })
          .then((resp) => {
            if (resp.result) {
              this.numActiveDataset = resp.result.dataset;
              this.numParkedDataset = resp.result.parked_dataset;
              this.numDeletedDataset = resp.result.deleted_dataset;
            }
          });
      }
    },
    async getDetailedImages() {
      if (!this.hasDetailedImages) {
        await this.dsConn.getDetailedImages({ organization_id: this.orgId })
          .then((resp) => {
            if (resp.result) {
              this.numActiveImages = resp.result.images;
              this.numParkedImages = resp.result.parked_images;
              this.numDeletedImages = resp.result.deleted_images;
            }
          });
      }
    },
    parseReport(data) {
      // Storage cost
      const storage_array = data.filter((e) => e.type === 'storage_size');
      const reduced_storage_array = storage_array.reduce((acc, curr) => {
        const obj = {
          type: "Storage (Duration in Days)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: this.costPackage['storage'][0]['dollar_cost_per_unit'] >= 1 ? `$${this.costPackage['storage'][0]['dollar_cost_per_unit']}/GB/month`
            : `\u00A2${this.costPackage['storage'][0]['dollar_cost_per_unit'] * 100}/GB/month`,
          amount: this.formatBytes(curr.amount),
          duration: `${curr.duration}d`,
          dollars: this.getDollarCost('storage', curr.amount, curr.duration, 1),
        };
        if (Number(obj.dollars) !== 0) {
          acc.push(obj);
        }
        return acc;
      }, []);
      this.storageRecord = reduced_storage_array;

      // Parked storage cost
      const parked_storage_array = data.filter((e) => e.type === 'parked_storage_size');
      const reduced_parked_storage_array = parked_storage_array.reduce((acc, curr) => {
        const obj = {
          type: "Parked Storage (Duration in Days)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: this.costPackage['storage'][0]['dollar_cost_per_unit'] * 0.5 >= 1 ? `$${this.costPackage['storage'][0]['dollar_cost_per_unit'] * 0.5}/GB/month`
            : `\u00A2${this.costPackage['storage'][0]['dollar_cost_per_unit'] * 100 * 0.5}/GB/month`,
          amount: this.formatBytes(curr.amount),
          duration: `${curr.duration}d`,
          dollars: this.getDollarCost('storage', curr.amount, curr.duration, 0.5),
        };
        if (Number(obj.dollars) !== 0) {
          acc.push(obj);
        }
        return acc;
      }, []);
      this.parkedStorageRecord = reduced_parked_storage_array;

      // File Count cost
      const file_count_array = data.filter((e) => e.type === 'num_files');
      const reduced_file_count_array = file_count_array.reduce((acc, curr) => {
        const obj = {
          type: "File Count (Duration in Days)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: this.costPackage['files'][0]['dollar_cost_per_unit'] * 1000 >= 1 ? `$${this.costPackage['files'][0]['dollar_cost_per_unit'] * 1000}/1000 files/month`
            : `\u00A2${this.costPackage['files'][0]['dollar_cost_per_unit'] * 100 * 1000}/1000 files/month`,
          amount: curr.amount,
          duration: `${curr.duration}d`,
          dollars: this.getDollarCost('files', curr.amount, curr.duration, 1),
        };
        if (Number(obj.dollars) !== 0) {
          acc.push(obj);
        }
        return acc;
      }, []);
      this.fileCountRecord = reduced_file_count_array;

      // File Count cost
      const seats_array = data.filter((e) => e.type === 'num_seats');
      const reduced_seats_array = seats_array.reduce((acc, curr) => {
        const obj = {
          type: "User Count (Duration in Days)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: this.costPackage['seats'][0]['dollar_cost_per_unit'] >= 1 ? `$${this.costPackage['seats'][0]['dollar_cost_per_unit']}/extra user/month`
            : `\u00A2${this.costPackage['seats'][0]['dollar_cost_per_unit']}/extra user/month`,
          amount: curr.amount,
          duration: `${curr.duration}d`,
          dollars: this.getDollarCost('num_seats', curr.amount, curr.duration, 1),
        };
        if (Number(obj.dollars) !== 0) {
          acc.push(obj);
        }
        return acc;
      }, []);
      this.seatsRecord = reduced_seats_array;

      // service
      const service_array = data.filter((e) => e.type === 'service');
      const reduced_service_array = service_array.reduce((acc, curr) => {
        const obj = {
          type: "Service Charge",
          description: "Monthly service charge based on usage",
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          amount: '-',
          rate: '-',
          duration: `${curr.duration}d`,
          dollars: Math.abs(curr.dollar_change),
        };
        if (curr.dollar_change !== 0) {
          acc.push(obj);
        }
        return acc;
      }, []);
      this.serviceRecord = reduced_service_array;

      // training
      const training_array = data.filter((e) => e.type === 'training_time');
      const reduced_training_array = training_array.reduce((acc, curr) => {
        const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
        const obj = {
          type: "Training Time (Duration in Hours)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: cost.rate,
          duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
          amount: '-',
          dollars: cost.dollars,
        };
        acc.push(obj);
        return acc;
      }, []);
      this.trainingTimeRecord = reduced_training_array;

      // aigt
      const aigt_array = data.filter((e) => e.type === 'aigt_time');
      const reduced_aigt_array = aigt_array.reduce((acc, curr) => {
        const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
        const obj = {
          type: "AI Assisted Ground Truth (Duration in Hours)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: cost.rate,
          duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
          amount: '-',
          dollars: cost.dollars,
        };
        acc.push(obj);
        return acc;
      }, []);
      this.aigtRecord = reduced_aigt_array;

      // autoann
      // const autoann_array = data.filter((e) => e.type === 'auto_annotations');
      // const reduced_autoann_array = autoann_array.reduce((acc, curr) => {
      //   const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
      //   const obj = {
      //     type: "Auto Annotations (Duration in Hours)",
      //     description: curr.comments,
      //     date: new Date(curr.date).toLocaleString('default', {
      //       year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
      //     }),
      //     rate: cost.rate,
      //     duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
      //     amount: '-',
      //     dollars: cost.dollars,
      //   };
      //   acc.push(obj);
      //   return acc;
      // }, []);
      // this.autoAnnRecord = reduced_autoann_array;
      this.autoAnnRecord = [];

      // validation
      const validation_array = data.filter((e) => e.type === 'validation');
      const reduced_validation_array = validation_array.reduce((acc, curr) => {
        const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
        const obj = {
          type: "Validations (Duration in Hours)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: cost.rate,
          duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
          amount: '-',
          dollars: cost.dollars,
        };
        acc.push(obj);
        return acc;
      }, []);
      this.validationTimeRecord = reduced_validation_array;

      // snapshot_restore
      const snapshot_restore_array_array = data.filter((e) => e.type === 'snapshot-restore');
      const reduced_snapshot_restore_array = snapshot_restore_array_array.reduce((acc, curr) => {
        const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
        const obj = {
          type: "Snapshot Restore (Duration in Hours)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: cost.rate,
          duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
          amount: '-',
          dollars: cost.dollars,
        };
        acc.push(obj);
        return acc;
      }, []);
      this.snapshotRestoreRecord = reduced_snapshot_restore_array;

      // snapshot_creation
      const snapshot_creation_array = data.filter((e) => e.type === 'snapshot-create');
      const reduced_snapshot_creation_array = snapshot_creation_array.reduce((acc, curr) => {
        const cost = this.getDollarCostForCloudInstances(curr.instance_type, curr.duration);
        const obj = {
          type: "Snapshot Creation (Duration in Hours)",
          description: curr.comments,
          date: new Date(curr.date).toLocaleString('default', {
            year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true, timeZone: this.timeZone,
          }),
          rate: cost.rate,
          duration: `${Number(curr.duration).toFixed(3).toLocaleString()}h`,
          amount: '-',
          dollars: cost.dollars,
        };
        acc.push(obj);

        return acc;
      }, []);
      this.snapshotCreationRecord = reduced_snapshot_creation_array;
    },
    timeOut() {
      this.refreshTimeOut = true;
      setTimeout(() => { this.refreshTimeOut = false; }, 10000);
    },
    getDollarCost(key, count, duration, modifier) {
      let cost_range = null;
      let prorated = 1;
      let newModifier = modifier;
      switch (key) {
      case "storage":
        cost_range = this.costPackage['storage'];
        newModifier *= 1e-9;
        prorated = duration / 30.0;
        break;
      case "files":
        cost_range = this.costPackage['files'];
        prorated = duration / 30.0;
        break;
      case "num_seats":
        cost_range = this.costPackage['seats'];
        prorated = duration / 30.0;
        break;
      default:
        break;
      }

      return Number(count * cost_range[0]['dollar_cost_per_unit'] * prorated * newModifier);
    },
    getDollarCostForCloudInstances(type, duration) {
      const pkgName = this.organization.package_name;
      const instance = this.instances.find((inst) => inst.type === type && inst.package === pkgName);
      if (!instance) {
        return {
          dollars: 0,
          rate: "$0/hour",
        };
      }
      return {
        dollars: Number(duration * instance["price"]),
        rate: instance["price"] > 1 ? `$${instance["price"]}/hour` : `\u00A2${instance["price"]}/hour`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.progress-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-col {
  display: flex;
  flex-direction: column;
}

.refresh-usage {
  width: fit-content;
}
.settings {
  display: flex;
  flex-direction: column;
  min-width: 400px;
  height: 100%;
  margin: 20px;
}

@media (max-width: $breakpoint-md) {
  .settings {
    min-width: 100%;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.date-selector {
  width: 380px;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  font-size: 1rem;
  font-weight: 500;

  select + select {
    margin-left: 20px;
  }

  button {
    margin-left: 20px;
  }
}

.static-summary {
  width: 100%;
  display: grid;
  grid-gap: 30px;
  padding: 15px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-auto-rows: auto;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
  @include themify() {
    background: themed('card-color');
    color: themed('body-text-color');
  }

  &__item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .icon +.progress {
      margin-left: 16px;
    }
  }

  &__item > .label {
    width: 200px;
    text-align: right;
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(grey, 0.9);

    &.required::after {
      content: '*';
      font-size: 14px;
      font-weight: 700;
      padding-left: 1px;
      @include themify() {
        color: themed('color-primary');
      }
    }
  }

  &__item > .value {
    flex: 1 1 auto;
    font-size: 0.9rem;
    margin-left: 20px;
  }
}




.header {
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header-2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.subtitle {
  font-size: 0.9rem;
  color: var(--body-text-color-secondary);
}

.icon {
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__title {
    display: flex;
    width: 100%;
    font-size: 1.0rem;
    font-weight: 600;
    @include themify() {
    color: themed('body-text-color');
    }
    span {
      margin-right: 5px
    }
  }

  &__subtitle {
    display: flex;
    width: 100%;
    font-size: 1rem;
    font-weight: 600;
    justify-content: space-between;
    @include themify() {
    color: themed('body-text-color-secondary');
    }

    div:first-child {
    margin-bottom: 5px;
    }
  }

  &__bar {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 1px;

      progress {
      width: 100%;
      border-radius: 0;
      height: 10px;

        &::-webkit-progress-bar {
            @include themify() {
            background-color: themed('progress-bar');
            }
        }
        &::-webkit-progress-value {
            @include themify() {
            background-color: themed('progress-value');
            }
        }
      }
  }

  &__estimate {
      display: flex;
      font-weight: 600;
      font-size: 0.875rem;
      @include themify() {
      color: themed('body-text-color-secondary');
      }
      margin-top: 5px;
      justify-content: space-between;
  }
}
.usage-monitor {
  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .radio-group input[type="radio"] + label {
    min-width: 6rem;
    max-width: 50%;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.5;
    padding: 5px 20px;
    transition: all 0s ease;
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');
    }
  }

  .radio-group input[type="radio"]:not(:disabled):hover + label {
    @include themify() {
      background: themed('color-primary-300');
      color: themed('primary-text-color');
    }
  }

  .radio-group input[type="radio"]:checked + label,
  .radio-group input[type="radio"]:checked:hover + label {
    opacity: 1;
    z-index: 1;
    @include themify() {
      background: themed('color-primary');
      color: themed('primary-text-color');
    }
  }

  .table-container {
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');

    }
  }

  :deep(tbody tr:nth-of-type(odd)) {
    background-color: rgba(0, 0, 0, .05);
  }

  :deep(thead > tr > th:nth-child(1)) {
    color: transparent;
    max-width: 60px;
  }
  .table-flex-end {
    display: flex;
    justify-content: end;

      span {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .total-credit-group{
    text-align: end;
    font-weight: 550;

    span {
      margin-left: auto;
      font-size: 1.0rem;
    }
  }

  .radio-group {
    display: inline-block;
    margin: 10px 0 20px 0;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px black
  }

  .radio-group input[type="radio"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .radio-group input[type="radio"] + label {
    min-width: 6rem;
    max-width: 50%;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.5;
    padding: 5px 20px;
    transition: all 0s ease;
    @include themify() {
      background: themed('card-color');
      color: themed('body-text-color');
    }
  }

  .radio-group input[type="radio"]:not(:disabled):hover + label {
    @include themify() {
      background: themed('color-primary-300');
      color: themed('primary-text-color');
    }
  }

  .radio-group input[type="radio"]:checked + label,
  .radio-group input[type="radio"]:checked:hover + label {
    opacity: 1;
    z-index: 1;
    @include themify() {
      background: themed('color-primary');
      color: themed('primary-text-color');
    }
  }
}

.added-fund {
  color: var(--color-success)
}

.unit {
  font-size: 0.85rem !important;
  font-weight: 500 !important;
}

.detail-icon {
  cursor: pointer;
  @include themify() {
    color: themed('icon-color-primary');
  }
  &:hover {
    @include themify{
      background-color: themed('icon-hover-color');
      border-radius: 100%;
      box-shadow: 0 0 0 4px themed('icon-hover-color');
    }
  }
}

.date-col {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .tz-selector {
    margin-left: 5px;

    input[type="radio"] {
      display: none;
    }

    label {
      padding: 2px 5px;
      width: fit-content;
      font-size: 0.85rem;
      font-weight: bold;
      color: var(--gray-500);
      cursor: pointer;
    }

     input[type="radio"]:checked+label {
      @include themify() {
        color: themed('color-primary-500');
      }
    }
  }
}
</style>
